export type Route =
  | { name: 'home' }
  | { name: 'list'; token: string; mode: 'edit' | 'view' | 'admin' }
  | { name: 'notfound' }

function parse(pathname: string): Route {
  if (pathname === '/' || pathname === '') return { name: 'home' }
  const match = /^\/(e|v|a)\/([^/]+)\/?$/.exec(pathname)
  if (match) {
    const prefix = match[1]
    return {
      name: 'list',
      token: decodeURIComponent(match[2] as string),
      mode: prefix === 'e' ? 'edit' : prefix === 'a' ? 'admin' : 'view',
    }
  }
  return { name: 'notfound' }
}

class Router {
  route = $state<Route>({ name: 'home' })
  query = $state<URLSearchParams>(new URLSearchParams())

  init(): void {
    this.read()
    window.addEventListener('popstate', () => this.read())
    document.addEventListener('click', this.onClick)
  }

  private read(): void {
    this.route = parse(window.location.pathname)
    this.query = new URLSearchParams(window.location.search)
  }

  navigate(path: string, options: { replace?: boolean } = {}): void {
    window.history[options.replace ? 'replaceState' : 'pushState']({}, '', path)
    this.read()
    window.scrollTo(0, 0)
  }

  /** Drops a query string without adding a history entry. */
  clearQuery(): void {
    window.history.replaceState({}, '', window.location.pathname)
    this.query = new URLSearchParams()
  }

  private onClick = (event: MouseEvent): void => {
    if (event.defaultPrevented || event.button !== 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    const anchor = (event.target as HTMLElement | null)?.closest?.('a')
    if (!anchor) return
    const href = anchor.getAttribute('href')
    if (
      !href?.startsWith('/') ||
      anchor.hasAttribute('target') ||
      anchor.hasAttribute('download')
    ) {
      return
    }
    if (anchor.dataset.native !== undefined) return
    event.preventDefault()
    this.navigate(href)
  }
}

export const router = new Router()
